// Cookie consent banner on the public website (app/views/site/_cookie_consent).
// Shown only when no choice is stored. Accept loads Google Analytics right away
// (site/analytics.ts); Decline loads nothing. "Cookie settings" in the footer
// ([data-cookie-settings]) forgets the choice, stops GA and shows the banner again.
import { applyConsent, CONSENT_KEY, storedConsent } from "./analytics"

function store(value: string | null) {
  try {
    if (value) localStorage.setItem(CONSENT_KEY, value)
    else localStorage.removeItem(CONSENT_KEY)
  } catch {
    // localStorage unavailable (private mode) — the choice lasts this page only.
  }
}

function banner() {
  return document.querySelector<HTMLElement>("[data-controller='cookie-consent']")
}

export function initCookieConsent() {
  const element = banner()
  if (element) {
    element.hidden = storedConsent() !== null
    element.querySelectorAll<HTMLButtonElement>("[data-cookie-consent]").forEach((button) => {
      button.addEventListener("click", () => {
        const value = button.dataset.cookieConsent === "granted" ? "granted" : "denied"
        store(value)
        applyConsent(value)
        element.hidden = true
      })
    })
  }

  // Delegated: the React footer re-renders on every Inertia visit.
  document.addEventListener("click", (event) => {
    const link = (event.target as Element | null)?.closest?.("[data-cookie-settings]")
    if (!link) return
    event.preventDefault()
    store(null)
    applyConsent(null)
    const current = banner()
    if (current) {
      current.hidden = false
      current.querySelector<HTMLButtonElement>("[data-cookie-consent]")?.focus()
    }
  })
}
